import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path1/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "extended-search"
    }}>{`Extended Search`}</h2>
    <p><inlineCode parentName="p">{`Cartsy`}</inlineCode>{` theme is build on `}<inlineCode parentName="p">{`Gutenberg Blocks`}</inlineCode>{`. In our theme we have provided few native gutenberg blocks using those blocks we have configured our theme pages. You can also use those blocks to add them to any pages or blogs. Below image shows all the gutenberg blocks our theme offers.`}</p>
    <pre><code parentName="pre" {...{}}>{`Still now Extended Search is not fully compatible with RNB plugin. 
Extended Search for RNB will be available in future update.
`}</code></pre>
    <p><a parentName="p" {...{
        "href": "https://youtu.be/o7CFJxo_RPk"
      }}>{`You can watch the video for search page setting.`}</a></p>
    <h2 {...{
      "id": "extended-search-backend"
    }}>{`Extended Search Backend`}</h2>
    <p><img alt="Extended Search" src={require("./images/extended-search/001.png")} />{`
`}<img alt="Extended Search" src={require("./images/extended-search/002.png")} />{`
`}<img alt="Extended Search" src={require("./images/extended-search/003.png")} />{`
`}<img alt="Extended Search" src={require("./images/extended-search/004.png")} />{`
`}<img alt="Extended Search" src={require("./images/extended-search/005.png")} />{`
`}<img alt="Extended Search" src={require("./images/extended-search/006.png")} /></p>
    <h2 {...{
      "id": "extended-search-frontend"
    }}>{`Extended Search Frontend`}</h2>
    <p><img alt="Extended Search" src={require("./images/extended-search/front-007.png")} />{`
`}<img alt="Extended Search" src={require("./images/extended-search/front-008.png")} />{`
`}<img alt="Extended Search" src={require("./images/extended-search/front-009.png")} />{`
`}<img alt="Extended Search" src={require("./images/extended-search/front-010.png")} />{`
`}<img alt="Extended Search" src={require("./images/extended-search/front-011.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      